import { UserService } from '@shared/services/user_service';
import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnInit,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { InfoPagesComponent } from '../info-pages.component';
import { Post } from '@shared/types/post';
import { ModalDirective } from '@shared/directives/modal/modal.directive';
import { TrackingService } from '@shared/services/tracking_service';

@Component({
  selector: 'postd-intro-creators',
  templateUrl: './intro-creators.component.html',
  styleUrls: ['./intro-creators.component.scss'],
})
export class IntroCreatorsComponent implements OnInit, AfterViewInit {
  @ViewChild('featuredPostsCarousel') featuredPostsCarousel: ElementRef;
  @ViewChild('signInModal', { read: ModalDirective }) signInModal: ModalDirective;
  loggedIn: boolean;
  parentComponent: InfoPagesComponent;
  featuredPosts: Post[];

  isBrowser = true;
  thumbnailOptions = { hideDescription: true, disableLink: true };

  constructor(
    protected userService: UserService,
    @Inject(PLATFORM_ID) protected platformId: Object,
    protected trackingService: TrackingService,
    protected router: Router,
    protected route: ActivatedRoute
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    if (!isPlatformBrowser(this.platformId)) {
      this.signInModal = null; // Prevent server memory leak
    }

    userService.curUser$.subscribe((user) => {
      this.loggedIn = !!(user && user.id);
    });
  }

  ngOnInit() {
    if (!this.featuredPosts) {
      this.featuredPosts = this.route.snapshot.data['featuredPosts'];
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      const element: HTMLDivElement = this.featuredPostsCarousel?.nativeElement;
      if (element) {
        element.scrollLeft = element.scrollWidth / 2;
      }
    });
  }

  getStarted() {
    // FIXME  This should go to some wizard to guide  you step by step
    //  though the process: register, create channel, create post
    if (this.loggedIn) {
      this.router.navigate(['/manage-v2/post/video']);
    } else {
      if (this.isBrowser) {
        this.userService.redirect_uri = window.location.origin + '/info/signup-thankyou';
      }

      this.signInModal.open();
      this.trackingService.trackPid('nzsks', { tw_sale_amount: 0, tw_order_quantity: 0 });

      // if (this.parentComponent) {
      //   this.parentComponent.signin();
      // }
    }
  }

  loginWithTransact() {
    this.userService.login(false);
  }

  registerWithTransact() {
    this.userService.login(true);
  }
}
